import script from "./ProjectDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDetailView.vue?vue&type=style&index=0&id=bba85840&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bba85840"]])

export default __exports__